// The one-time link code (FR-012; data-model §10): read once from `?token=` and kept in memory for
// the page's life, then removed from the address, the browser history and the router params in a
// layout effect, which runs before any effect that sends it. Never stored, logged or rendered.
import { useLocalSearchParams, useRouter } from "expo-router";
import { useLayoutEffect, useState } from "react";

import { scrubTokenFromAddress } from "./scrubTokenFromAddress";

export function useLinkToken(): string | null {
  const params = useLocalSearchParams<{ token?: string | string[] }>();
  const router = useRouter();
  const [token] = useState<string | null>(() => {
    const raw = Array.isArray(params.token) ? params.token[0] : params.token;
    return typeof raw === "string" && raw !== "" ? raw : null;
  });

  const hadToken = params.token !== undefined;
  useLayoutEffect(() => {
    if (!hadToken) return;
    scrubTokenFromAddress();
    router.setParams({ token: undefined });
  }, [hadToken, router]);

  return token;
}
